import * as React from 'react';

import cn from 'classnames';

import { Translate } from '@decorators';

import { getRandomStr, noop } from '@common/utils';

import { Icon } from '@components/Icon';

import { IconAdd } from '@icons';

import { IFileButtonProps } from './types';

import * as s from './FileButton.scss';

@Translate('base.components.ui.FileButton')
export class FileButton extends React.Component<IFileButtonProps> {

	static defaultProps: Partial<IFileButtonProps> = {
		isMultipleUpload: false,
		id: getRandomStr(),
		format: '*',
		onChange: noop,
	};

	render() {
		const {
			isMultipleUpload,
			id,
			format,
			onChange,
			name,
			isValid,
			title = this.t('chooseFile'),
		} = this.props;
		const accept = Array.isArray(format) ? format.join(',') : format;

		return (
			<div className={s.container}>
				<label
					htmlFor={id}
					className={cn(s.label, {
						[s.error]: !isValid,
					})}
				>
					<input
						type="file"
						multiple={isMultipleUpload}
						accept={accept}
						className={s.input}
						id={id}
						name={name}
						onChange={onChange}
					/>
					<Icon glyph={IconAdd} className={s.icon}/>
					<span className={s.text}>{title}</span>
				</label>
			</div>
		);
	}

}
